import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Report from '../views/Report.vue'
import QuotaCalculator from '../views/QuotaCalculator'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '',
    component: Home
  },
  {
    path: '/Home',
    name: 'Home',
    component: Home
  },
  {
    path: '/Report',
    name: 'Report',
    component: Report
  },
  {
    path: '/QuotaCalculator',
    name: 'QuotaCalculator',
    component: QuotaCalculator
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '#',
  routes
})

export default router
